const pubgInfo = { gameId: 'PUBG', image: '/shared/img/header-nav/pubg/ico-pubg.svg', title: '펍지 레벨업 쇼다운' };

export default {
  pubg: { ...pubgInfo, league: 'PUBG_AMATEUR_PLS_3' },
};
